import './App.css';
import { Navbar } from './Components/Navbar';
import  Home  from './Pages/Home/Home';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
      
  );
}

export default App;
